import { ThreePlanogram } from "../store/types";
import { PlanogramShelf } from "@CommonTypes/merchflow/pog/shelf";
import { Shelf } from "./Shelf";

interface Props {
  shelves: PlanogramShelf[];
  three: ThreePlanogram;
}

export const Shelves = ({ shelves, three }: Props) => {
  return shelves.map((shelf) => <Shelf key={shelf.uniqueId} shelf={shelf} three={three} />);
};
